import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ICreateCampaignBriefForm } from './create-campaign-dialog.interface';

// Mirrors CampaignManagementAPI's POST /brief/analyze limits, so a request it would refuse is never sent.
export const BRIEF_FILE_EXTENSIONS = ['pdf', 'docx', 'txt'];
export const BRIEF_MAX_FILES = 3;
// The backend allows 10 MiB; decimal MB keeps the "10 MB" error message exact.
export const BRIEF_MAX_FILE_SIZE_BYTES = 10_000_000;
export const BRIEF_MAX_TOTAL_SIZE_BYTES = 20 * 1024 * 1024;
export const BRIEF_MAX_FILE_NAME_LENGTH = 64;
export const BRIEF_MAX_PROMPT_LENGTH = 8000;

export function briefSourceRequiredValidator(control: AbstractControl): ValidationErrors | null {
  const { files, prompt } = (control as FormGroup<ICreateCampaignBriefForm>).controls;

  return files.length || prompt.value?.trim() ? null : { briefSourceRequired: true };
}

export function maxFileNameLengthValidator(maxLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const file: File | null = control.value;

    return file && file.name.length > maxLength ? { maxFileNameLength: { maxLength } } : null;
  };
}

export function maxTotalFileSizeValidator(getSelectedBytes: () => number, maxTotalBytes: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const file: File | null = control.value;

    if (!file?.size || getSelectedBytes() + file.size <= maxTotalBytes) {
      return null;
    }

    return { maxTotalFileSize: { maxSizeInMb: maxTotalBytes / (1024 * 1024) } };
  };
}
